/* global fetch, RequestInit, Response, AbortSignal, Headers */
import { getAppToken } from "../auth/authService";
import { BACKEND_URL } from "../config";

// Thin wrapper around fetch() that attaches the backend app JWT and resolves
// relative paths against BACKEND_URL. Every authenticated backend call (analyse,
// generate, quick-score, coaching-detail, history) should go through this.
export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const token = await getAppToken();
  const headers = new Headers(init.headers ?? {});
  headers.set("Authorization", `Bearer ${token}`);
  if (init.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  return fetch(`${BACKEND_URL}${path}`, { ...init, headers });
}

// Convenience GET returning parsed JSON; throws on a non-2xx response.
export async function apiGet<T>(path: string, signal?: AbortSignal): Promise<T> {
  const res = await apiFetch(path, { method: "GET", signal });
  if (!res.ok) throw new Error(`GET ${path} failed: ${res.status}`);
  return (await res.json()) as T;
}
